"use client"

import { useEffect, useRef, useState } from "react"
import { useTranslation } from "../../../i18n"

export default function BikeParkinStatsSection() {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState("today")
  const chartRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    if (!chartRef.current) return

    const ctx = chartRef.current.getContext("2d")
    if (!ctx) return

    // Simple line chart für BikeParking Nutzung
    const width = chartRef.current.width
    const height = chartRef.current.height

    ctx.clearRect(0, 0, width, height)

    // Draw line für Fahrradparkplatz-Auslastung
    ctx.beginPath()
    ctx.moveTo(0, height * 0.8)
    ctx.lineTo(width * 0.2, height * 0.7)
    ctx.lineTo(width * 0.4, height * 0.5)
    ctx.lineTo(width * 0.6, height * 0.3)
    ctx.lineTo(width * 0.8, height * 0.4)
    ctx.lineTo(width, height * 0.2)

    ctx.strokeStyle = "#10b981"
    ctx.lineWidth = 2
    ctx.stroke()

    // Fill area under the line
    ctx.lineTo(width, height)
    ctx.lineTo(0, height)
    ctx.closePath()

    const gradient = ctx.createLinearGradient(0, 0, 0, height)
    gradient.addColorStop(0, "rgba(16, 185, 129, 0.2)")
    gradient.addColorStop(1, "rgba(16, 185, 129, 0.0)")
    ctx.fillStyle = gradient
    ctx.fill()
  }, [activeTab])

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 w-full h-full">
      {/* Tabs */}
      <div className="flex space-x-4 mb-4">
        <button
          className={`text-sm ${activeTab === "today" ? "text-green-600 font-medium" : "text-gray-500"}`}
          onClick={() => setActiveTab("today")}
        >
          {t('bikeParking.stats.today')}
        </button>
        <button
          className={`text-sm ${activeTab === "week" ? "text-green-600 font-medium" : "text-gray-500"}`}
          onClick={() => setActiveTab("week")}
        >
          {t('bikeParking.stats.week')}
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-2 mb-4">
        <div>
          <div className="text-xs text-gray-500">{t('bikeParking.stats.utilization')}</div>
          <div className="text-lg font-medium">87,3%</div>
          <div className="text-xs text-gray-500">14:05</div>
        </div>
        <div>
          <div className="text-xs text-gray-500">{t('bikeParking.stats.yesterday')}</div>
          <div className="text-lg font-medium">82,1%</div>
          <div className="text-xs text-gray-500">23:59</div>
        </div>
      </div>

      {/* Chart */}
      <div className="h-24 w-full">
        <canvas ref={chartRef} width={300} height={100} className="w-full h-full"></canvas>
      </div>

      <div className="flex justify-between text-xs text-gray-500 mt-1">
        <div>06:00</div>
        <div>{t('bikeParking.stats.now')}</div>
      </div>

      <div className="text-xs text-gray-500 mt-2">{t('bikeParking.stats.title')}</div>
    </div>
  )
}
